module.exports = __webpack_public_path__ + "img/safety_supervision.62e26a4d.png";